import { useState } from 'react'

import { $isTableNodeFocusedAtSelection } from '../../utils/table'
import { useSelectionChange } from '../useSelectionChange'

export const useTableForced = () => {
  const [forced, setForced] = useState(false)

  useSelectionChange(() => {
    const tableForced = $isTableNodeFocusedAtSelection()
    setForced(tableForced)
    return false
  })

  return forced
}
